import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as q, useCssModule as J, useAttrs as Q, ref as m, computed as E, onMounted as X, onUnmounted as Y, createElementBlock as b, openBlock as _, normalizeClass as v, normalizeStyle as Z, unref as t, createVNode as y, withCtx as C, createElementVNode as ee, Fragment as R, renderList as I, withKeys as L, renderSlot as N, mergeProps as M, createBlock as z, createCommentVNode as ae, withModifiers as te, resolveDynamicComponent as re } from "vue";
import h from "../../utils/mapClasses.mjs";
import { useElementHover as oe, useDebounceFn as P, useEventListener as se, useResizeObserver as le } from "@vueuse/core";
import { ScrollAreaRoot as ne, ScrollAreaViewport as ie, ScrollAreaScrollbar as fe, ScrollAreaThumb as ue } from "radix-vue";
import ce from "../button/CdrButton.vue.mjs";
import me from "../icon/comps/caret-left.vue.mjs";
import de from "../icon/comps/caret-right.vue.mjs";
const ve = ["id", "data-ui"], he = ["id", "data-ui"], i = "cdr-filmstrip", Me = /* @__PURE__ */ q({
  name: "CdrFilmstripEngine",
  __name: "CdrFilmstripEngine",
  props: {
    id: {
      default: ""
    },
    description: {
      default: ""
    },
    dataUi: {
      default: i
    },
    isShowingArrows: {
      type: Boolean,
      default: !0
    },
    frames: {
      default: () => []
    },
    framesToShow: {
      default: 5
    },
    framesToScroll: {
      default: 4
    },
    framesGap: {
      default: 0
    },
    frameExtra: {
      default: 0.25
    },
    focusSelector: {
      default: ":first-child"
    },
    viewportTabindex: {
      default: "-1"
    }
  },
  emits: ["arrowClick", "scrollNavigate", "ariaMessage"],
  setup(G, {
    emit: U
  }) {
    const u = J(), s = G, l = Q().class || "", w = U, p = m(""), g = m(null), $ = m(null), k = m(null), T = m(0), f = m(0), c = m(0), V = oe(g), S = m(!1), x = E(() => {
      const e = s.framesToShow * s.framesGap;
      return (T.value - e) / (s.framesToShow + s.frameExtra);
    }), W = E(() => ({
      "--frames-gap": s.framesGap,
      "--frame-width": x.value,
      "--frame-extra": s.frameExtra
    })), O = E(() => {
      const e = f.value === 0, r = f.value >= s.frames.length - s.framesToShow;
      return ["left", "right"].map((a) => {
        const o = a === "left" ? !e : !r;
        return {
          direction: a,
          icon: a === "left" ? me : de,
          attributes: {
            "data-ui": `${i}__arrow--${a}`,
            class: [h(u, `${i}__arrow`, `${i}__arrow--${a}`, o ? "" : `${i}__arrow--disabled`), l ? `${l}__arrow` : null, l ? `${l}__arrow--${a}` : null, o ? "" : l && `${i}__arrow--disabled`].filter(Boolean).join(" "),
            "aria-label": `${a === "right" ? "Next" : "Previous"} Frame`,
            "aria-controls": `${s.id}-frames`,
            tabindex: 0,
            size: "large",
            disabled: !o
          }
        };
      });
    }), A = (e) => {
      const r = x.value * e, a = s.framesGap * e;
      return r + a;
    }, D = (e) => {
      var o, n;
      const r = A(e), a = ((o = $.value) == null ? void 0 : o.viewportElement.scrollLeft) ?? 0;
      (n = $.value) == null || n.viewportElement.scrollBy({
        left: r - a,
        behavior: "smooth"
      });
    }, F = (e, r) => {
      w("arrowClick", {
        event: e,
        direction: r
      });
      const o = r === "left" ? -s.framesToScroll : s.framesToScroll, n = f.value + o;
      f.value = Math.max(0, Math.min(n, s.frames.length - 1)), S.value = !0, D(f.value);
    }, H = P(() => {
      const e = s.frames.length, r = Math.max(1, f.value + 1), a = Math.min(e, r + s.framesToShow - 1);
      p.value = s.framesToShow === 1 ? `Now showing frame ${r} of ${e}` : `Now showing frames ${r} through ${a} of ${e}`, w("ariaMessage", p.value);
    }, 300), j = (e) => {
      const r = e.currentTarget;
      if (!r || !e.relatedTarget || !r.contains(e.relatedTarget)) {
        const a = s.frames.length, o = Math.max(1, f.value + 1), n = Math.min(a, o + s.framesToShow - 1);
        s.framesToShow === 1 ? p.value = `Showing frame ${o} of ${a}. Use left and right arrow keys to navigate.` : p.value = `Showing frames ${o} through ${n} of ${a}. Use left and right arrow keys to navigate.`, w("ariaMessage", p.value);
      }
    };
    function B(e, r) {
      if (e.preventDefault(), S.value = !0, r === "left" ? c.value = c.value <= 0 ? s.frames.length - 1 : c.value - 1 : c.value = c.value >= s.frames.length - 1 ? 0 : c.value + 1, k.value) {
        const o = k.value[c.value].querySelector(s.focusSelector);
        o && o.focus();
      }
    }
    const K = P((e) => {
      const r = e.target.scrollLeft, a = s.frames.map((n, d) => A(d)), o = a.findIndex((n) => Math.abs(n - r) === Math.min(...a.map((d) => Math.abs(d - r))));
      o !== f.value && (f.value = o, H()), S.value || w("scrollNavigate", {
        event: e,
        index: f.value
      }), S.value = !1;
    }, 100);
    return X(() => {
      var r, a;
      se((r = $.value) == null ? void 0 : r.viewportElement, "scroll", K);
      const {
        stop: e
      } = le(g, (o) => {
        o.forEach((n) => {
          T.value = n.contentRect.width;
        });
      });
      Y(() => {
        e();
      }), T.value = ((a = g.value) == null ? void 0 : a.offsetWidth) ?? 0;
    }), (e, r) => (_(), b("div", {
      id: e.id,
      ref_key: "containerRef",
      ref: g,
      "data-ui": e.dataUi,
      style: Z(W.value),
      class: v(t(u)[i]),
      onFocusin: j
    }, [y(t(ne), {
      type: "auto",
      class: v([t(h)(t(u), `${i}__root`), t(l) ? `${t(l)}__root` : null])
    }, {
      default: C(() => [y(t(ie), {
        ref_key: "framesRef",
        ref: $,
        class: v([t(h)(t(u), `${i}__viewport`), t(l) ? `${t(l)}__viewport` : null]),
        "aria-label": e.description || `${e.frames.length} items`,
        tabindex: e.viewportTabindex
      }, {
        default: C(() => [ee("ul", {
          id: `${e.id}-frames`,
          class: v([t(h)(t(u), `${i}__frames`), t(l) && `${t(l)}__frames`]),
          "data-ui": `${i}__frames`
        }, [(_(!0), b(R, null, I(e.frames, (a, o) => (_(), b("li", {
          key: a.key,
          ref_for: !0,
          ref_key: "framesItemsRef",
          ref: k,
          class: v([t(h)(t(u), `${i}__frame`), t(l) ? `${t(l)}__frame` : null]),
          onKeydown: [r[0] || (r[0] = L((n) => B(n, "right"), ["right"])), r[1] || (r[1] = L((n) => B(n, "left"), ["left"]))]
        }, [N(e.$slots, "frame", M({
          index: o,
          ref_for: !0
        }, a.props, {
          tabindex: o === c.value ? "0" : "-1"
        }))], 34))), 128))], 10, he)]),
        _: 3
      }, 8, ["class", "aria-label", "tabindex"]), y(t(fe), {
        class: v([t(h)(t(u), `${i}__bar`, `${i}__bar--horizontal`), t(l) ? `${t(l)}__bar` : null, t(l) ? `${t(l)}__bar--horizontal` : null]),
        orientation: "horizontal"
      }, {
        default: C(() => [y(t(ue), {
          class: v([t(h)(t(u), `${i}__thumb`), t(l) ? `${t(l)}__thumb` : null])
        }, null, 8, ["class"])]),
        _: 1
      }, 8, ["class"])]),
      _: 3
    }, 8, ["class"]), (_(!0), b(R, null, I(O.value, ({
      direction: a,
      attributes: o,
      icon: n
    }) => N(e.$slots, "arrow", M({
      ref_for: !0
    }, {
      attributes: o,
      direction: a,
      icon: n
    }, {
      onClick: (d) => F(d, a)
    }), () => [t(V) && s.isShowingArrows ? (_(), z(ce, M({
      key: a,
      "icon-only": !0,
      "with-background": !0,
      ref_for: !0
    }, o, {
      onClick: te((d) => F(d, a), ["prevent"])
    }), {
      icon: C(() => [(_(), z(re(n)))]),
      _: 2
    }, 1040, ["onClick"])) : ae("", !0)])), 256))], 46, ve));
  }
});
export {
  Me as default
};
